import React from 'react'

import { DefaultCoverageDetails } from './Cells'
import RAGIcon from 'FoundationalComponents/RAGIcon'

const CoverageCell = ({ value, Details = DefaultCoverageDetails }) => <RAGIcon {...Details(value)} />
const CoverageCellAttributes = ({ Header, accessor, CellToRender = CoverageCell, style = {}, Details = DefaultCoverageDetails }) => ({
  Header, accessor, width: 130, style,
  Cell: ({ value }) => <CellToRender {...{ value, Details }} />,
  sortMethod: (a, b) => a.toString() < b.toString() ? 1 : -1
})

export { CoverageCellAttributes, CoverageCell }
